<template>
  <div>
    <edit-form v-model="form" :form-path="formPath" @cancel="cancel">
      <template v-slot:buttons>
        <slot name="buttons" />
      </template>

      <template v-slot:additional>
        <v-row dense>
          <v-col cols="12"> {{ $t('ITEM.VALIDATION_RULES') }}: </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-checkbox
              v-model="form.el.required"
              dense
              hide-details
              :label="$t('ITEM.MANDATORY')"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="showName"
              hide-details
              dense
              inset
              :label="$t('FORM_BUILDER.ADD_FIELD_NAME')"
              @change="form.el.name = ''"
            ></v-switch>
          </v-col>
          <v-col v-if="showName" cols="12">
            <v-text-field
              v-model="form.el.name"
              :counter="255"
              :rules="rules.requiredTextLine"
              :label="$t('ITEM.NAME')"
            />
          </v-col>
        </v-row>
      </template>
    </edit-form>
  </div>
</template>

<script>
import EditForm from '@/modules/form_builder/components/formsComponents/editForms/EditForm';
import formEditable from '@/modules/_global/mixins/form-editable';
import { requiredTextLine } from '@/modules/_global/variables/rules';

export default {
  name: 'SingleFieldForm',

  components: {
    EditForm
  },

  mixins: [formEditable],

  data: () => ({
    rules: {
      requiredTextLine
    },
    showName: false,
    formPath:
      'modules/form_builder/components/forms/SingleEditLanguagesForm.vue'
  }),

  created() {
    this.showName = !!this.form.el.name.length;
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped></style>
